export const DEVICES_COLUMNS = [
  {
    sortKey: "name",
    title: "Nombre",
  },
  {
    sortKey: "",
    title: "Tipo",
  },
  {
    sortKey: "connectionId",
    title: "Estado del casco",
  },
  {
    sortKey: "createdAt",
    title: "Fecha",
  },
];
